import { graphql } from 'react-apollo'
import { compose } from 'recompose'

import withLocalization from './withLocalization'
import withFlattenedTranslations from './withFlattenedTranslations'
import withLoadingState from './withLoadingState'
import withErrorState from './withErrorState'
import withRedirectWhenEmpty from './withRedirectWhenEmpty'

import vehicleQuery from '../queries/vehicle'
import withConnectionStatus from "./withConnectionStatus";

export default compose(
  withLocalization,
  withConnectionStatus,
  graphql(vehicleQuery, {
    options: ({ language, match, fetchPolicy, stage }) => ({
      variables: {
        vehicleSlug: match.params.vehicleSlug,
        lang: language.toLowerCase(),
        stage
      },
      fetchPolicy
    })
  }),
  withErrorState,
  withLoadingState('vehicle', 'text'),
  withRedirectWhenEmpty('vehicle'),
  withFlattenedTranslations('vehicle')
)



// WEBPACK FOOTER //
// ./src/hocs/withVehicle.js